<template>
  <section>
    <!-- <div class="notification-banner" v-if="!hasThresholdValue">
      <div class="notification-header">
        <img src="../../assets/inventory.svg" class="w-4.5" />
        <p>Inventory notifications</p>
      </div>
      <div class="notification-cta">
        <p>
          Add stock threshold limit and get notified when your item runs low.
        </p>
        <button
          @click="showModal"
          class="whitebutton-gemnote button-gemnote-glass--tiny gray"
        >
          <span class="cursor-pointer">Setup</span>
        </button>
      </div>
    </div> -->
    <!-- <div class="notification-banner">
      <div class="notification-threshold">
        <div class="notification-header">
          <p>
            <strong>Stock threshold</strong>
          </p>
          &nbsp;
          <p class="text-sm">{{ stockThresholdValue }} total units/product</p>
          <img
            src="../../assets/edit.svg"
            alt=""
            class="w-3.5 relative left-0.5 cursor-pointer"
            @click="showModal"
          />
        </div>
        <div class="notification-header">
          <p>
            <strong>Notifications</strong>
          </p>
          &nbsp;
          <label class="toggle-button">
            <input
              type="checkbox"
              :checked="notificationsEnabled"
              @change="toggleNotifications"
            />
            <span class="toggle-slider round"></span>
          </label>
        </div>
      </div>
    </div> -->
    <!-- <div class="notification-alert-banner" v-if="!hasThresholdValue">
      <div class="notification-header">
        <img src="../../assets/inventory-warning.svg" class="w-4.5" />
        <p>Some items are running low in stock!</p>
      </div>
    </div> -->
    <StockThresholdModal
      :showFooter="false"
      :modalName="inventoryNotificationsModalName"
      v-show="isModalActive"
      @confirmAction="confirmFinalizeOrder($event)"
      buttonLabel="Finalize"
      colorVariation="coast"
      @closeModal="hideModal"
    >
      <template slot="header">
        <h4 class="header">Stock Threshold</h4>
      </template>

      <template slot="body">
        <p class="modal-description">
          Add a threshold value for your stock and get notified when an item in
          your inventory falls below the threshold value. You can change this at
          any time.
        </p>
        <div class="modal-form">
          <p>Stock threshold</p>
          <input
            type="number"
            v-model="thresholdValue"
            placeholder="0"
            class="input-gemnote"
          />
        </div>
        <div class="modal-cta">
          <button
            tag="button"
            :disabled="!thresholdValue || isLoading"
            class="button-gemnote button-gemnote--small"
            @click="handleSetStockThreshold"
          >
            <span>Set</span>
          </button>
        </div>
      </template>
    </StockThresholdModal>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'InventoryNotificationsBanner',
  data() {
    return {
      inventoryNotificationsModalName: 'inventoryNotificationsModal',
      thresholdValue: '',
      notificationsEnabled: false,
      isLoading: false
    }
  },
  components: {
    StockThresholdModal: () => import('@/components/Universal/RemoveModal')
  },
  computed: {
    ...mapGetters({
      activeModals: 'modal/activeModals'
    }),
    isModalActive() {
      return this.activeModals(this.inventoryNotificationsModalName)
    },
    ...mapState({
      productinventoryList: state => state.inventory.productInventoryList,
      stockThresholdValue: state => state.inventory.stockThresholdValue
    }),
    hasThresholdValue() {
      return this.stockThresholdValue > 0
    }
  },
  methods: {
    handleSetupInventoryNotifications() {
      this.$router.push({ name: 'inventory-notifications' })
    },
    toggleNotifications() {
      this.notificationsEnabled = !this.notificationsEnabled
    },
    hideModal() {
      this.$store.dispatch(
        'modal/hideRemoveModal',
        this.inventoryNotificationsModalName
      )
    },
    showModal() {
      this.$store.dispatch(
        'modal/showRemoveModal',
        this.inventoryNotificationsModalName
      )
    },
    async handleSetStockThreshold() {
      this.isLoading = true
      // this.hideModal()
      // this.productinventoryList.forEach((product, index) => {
      //   if (product.quantity < this.thresholdValue) {
      //     this.$store.dispatch('inventory/addProductToReplenish', {
      //       id: parseInt(product.id),
      //       originalIndex: index
      //     })
      //   }
      // })
      this.$store.dispatch('inventory/setStockThresholdLimit', {
        stockThresholdLimit: this.thresholdValue
      })
      this.isLoading = false
    }
  },
  mounted() {
    this.thresholdValue = this.stockThresholdValue
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.notification-banner {
  padding: 1.2rem;
  border: 1px solid #000000;
  border-radius: 2px;
  border-radius: 12px;

  .notification-threshold {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    align-items: center;
  }

  .notification-header {
    display: flex;
    align-items: center;
    gap: 0.3rem;

    p {
      font-size: 0.823rem;
      font-weight: 600;
    }
  }

  .notification-cta {
    position: relative;
    z-index: 999 !important;
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;

    p {
      font-size: 0.823rem;
      font-weight: 400;
      color: #232220;
      font-weight: 400;
      text-align: left;
    }

    .button-gemnote-glass--tiny {
      display: block !important;
      width: max-content !important;
      font-weight: 400 !important;
      font-size: 0.713rem !important;
      padding: 0 1rem !important;
      height: 1.7rem !important;
      cursor: pointer;
    }
  }
}
.notification-alert-banner {
  margin-top: 1rem;
  padding: 1.2rem;
  border-radius: 12px;
  background-color: #ce3c3c26;

  .notification-header {
    display: flex;
    align-items: center;
    gap: 0.3rem;

    p {
      font-size: 0.823rem;
      font-weight: 700;
      color: #ce3c3c;
    }
  }
}

.header {
  margin-bottom: 1.25rem;
  color: $pebble;
  font-family: $editorial;
  font-weight: normal;
  font-size: 2rem;
}

@media (max-width: 800px) {
  .header {
    line-height: 35px !important;
  }
}

.modal-description {
  font-size: 0.873rem;
  width: 80%;
  margin: 0 auto;
  color: $pebble;
  text-align: left;
}
@media (max-width: 800px) {
  .modal-description {
    width: 90%;
  }
}

.modal-form {
  display: flex;
  gap: 0.7rem;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;

  p {
    font-size: 0.873rem;
    color: $pebble;
    width: max-content;
    font-weight: bold;
  }

  input {
    width: 100px;
    border-bottom: 1px solid #000000;
    height: 100%;
    color: $pebble !important;

    &::placeholder {
      color: $pebble !important;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

.modal-cta {
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  button {
    padding: 0px 3rem !important;
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
